import { render, staticRenderFns } from "./MapCardTTS.vue?vue&type=template&id=7920e2ac&"
import script from "./MapCardTTS.vue?vue&type=script&lang=js&"
export * from "./MapCardTTS.vue?vue&type=script&lang=js&"
import style0 from "./MapCardTTS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports